var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.666,
    height: 20.855,
    viewBox: "0 0 29.666 20.855",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#1976D2;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.676,4.99a1.052,1.052,0,0,1,1.495,1.48l-7.58,7.58H28.6A1.053,1.053,0,0,1,29.665,15.1,1.066,1.066,0,0,1,28.6,16.157H3.591l7.58,7.565a1.073,1.073,0,0,1,0,1.495,1.047,1.047,0,0,1-1.495,0L.3,15.843a1.055,1.055,0,0,1,0-1.48Z",
    transform: "translate(0.001 -4.676)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.9e85550e105d1c63b3d90620933ad615.svg";
export { ForwardRef as ReactComponent };